import { IconsProps } from '@/types/shared'
import React from 'react'

const FeatureCheckIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 120 120"
                fill="none"
                className="w-full h-full drop-shadow-lg"
            >
                <circle cx="60" cy="60" r="45" fill="#FF6B6B" opacity="0.8" />
                <path
                    d="M40 50L55 65L85 35"
                    stroke="white"
                    strokeWidth="4"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <g fill="#FF6B6B">
                    <circle cx="20" cy="20" r="3" opacity="0.6" />
                    <circle cx="100" cy="30" r="2" opacity="0.7" />
                    <circle cx="15" cy="80" r="2.5" opacity="0.5" />
                    <circle cx="105" cy="90" r="3" opacity="0.6" />
                </g>
            </svg>
        </div>
    )
}

export default FeatureCheckIcons
